import { render } from "./MPMSFaceBeforeUseCaution.vue?vue&type=template&id=1becca51&scoped=true"
import script from "./MPMSFaceBeforeUseCaution.vue?vue&type=script&lang=js"
export * from "./MPMSFaceBeforeUseCaution.vue?vue&type=script&lang=js"

import "./MPMSFaceBeforeUseCaution.vue?vue&type=style&index=0&id=1becca51&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1becca51"

export default script